import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HaLandingComponent } from './ha-landing/ha-landing.component';
import { HaGeneralInfoComponent } from './ha-general-info/ha-general-info.component';
import { HaMedicalHistoryComponent } from './ha-medical-history/ha-medical-history.component';
import { HaLifestyleComponent } from './ha-lifestyle/ha-lifestyle.component';
import { PersonalInfoComponent } from './ha-general-info/personal-info/personal-info.component';
import { PrimaryCareComponent } from './ha-general-info/primary-care/primary-care.component';
import { HAMedicalConditionsComponent } from './ha-medical-history/medical-conditions/medical-conditions.component';
import { HealthGoalsComponent } from './ha-lifestyle/health-goals/health-goals.component';
import { HowYouEatComponent } from './ha-lifestyle/how-you-eat/how-you-eat.component';
import { HowYouMoveComponent } from './ha-lifestyle/how-you-move/how-you-move.component';
import { HowYouThinkComponent } from './ha-lifestyle/how-you-think/how-you-think.component';
import { WorkLifeBalanceComponent } from './ha-lifestyle/work-life-balance/work-life-balance.component';
import { HowYouSleepComponent } from './ha-lifestyle/how-you-sleep/how-you-sleep.component';
import { SubstanceAbuseComponent } from './ha-lifestyle/substance-abuse/substance-abuse.component';
import { SafetyComponent } from './ha-lifestyle/safety/safety.component';
import { ScreeningComponent } from './ha-medical-history/screening/screening.component';
import { MenHealthComponent } from './ha-medical-history/men-health/men-health.component';
import { WomenHealthComponent } from './ha-medical-history/women-health/women-health.component';
import { FamilyHistoryComponent } from './ha-medical-history/family-history/family-history.component';
import { HARoutingModule } from './ha-new.routing.module';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LookupService } from 'src/app/services/ha-new/lookup.service';
import { GeneralInfoService } from 'src/app/services/ha-new/general-info.service';
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { MatSliderModule } from '@angular/material/slider';
import { NewHAService } from 'src/app/services/ha-new/new-ha.service';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
import { MedicalHistoryService } from 'src/app/services/ha-new/medical-history.service';
import { LifestyleService } from 'src/app/services/ha-new/lifestyle.service';

@NgModule({
	imports: [
		CommonModule,
		HARoutingModule,
		HARoutingModule,
		MaterialModule,
		SharedModule,
		FormsModule,
		ReactiveFormsModule,
		MatStepperModule,
		MatIconModule,
		NgxPageScrollModule,
		NgxPageScrollCoreModule,
		MatSliderModule,
	],
	declarations: [
		HaLandingComponent,
		HaGeneralInfoComponent,
		HaMedicalHistoryComponent,
		HaLifestyleComponent,
		PersonalInfoComponent,
		PrimaryCareComponent,
		HAMedicalConditionsComponent,
		HealthGoalsComponent,
		HowYouEatComponent,
		HowYouMoveComponent,
		HowYouThinkComponent,
		WorkLifeBalanceComponent,
		HowYouSleepComponent,
		SubstanceAbuseComponent,
		SafetyComponent,
		ScreeningComponent,
		MenHealthComponent,
		WomenHealthComponent,
		FamilyHistoryComponent,
	],
	providers: [LookupService, GeneralInfoService, NewHAService, MedicalHistoryService, LifestyleService],
})
export class HaNewModule {}
